import * as constants from '../constants';
import { createSampleRow, editSampleRow } from '../actions';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.editSampleRow.success: {
            return { ...action.payload, responseStatus: 'success' };
        }

        case constants.editSampleRow.error: {
            return { ...action.payload, responseStatus: 'error' };
        }

        case constants.editSampleRow.try: {
            return initialState;
        }

        default:
            return state;
    }
}